const insightsData = [
    {
        insightType: 'WINNING_STREAK',
        insightTypeES: 'RACHA_GANADORAS',
        priority: 6,
        subtitleEN: 'Máx consecutive winning trades',
        subtitleES: 'Máximos ganados consecutivamente',
        subtitleJA: '最大連続勝利取引',
        subtitleKO: '최대 연속 성공 거래',
        subtitlePT: 'Máx negociações vencedoras consecutivas',
        subtitleTH: 'การเทรดที่ชนะติดต่อกันสูงสุด',
        subtitleVI: 'Tối đa thương mại chiến thắng liên tiếp',
        subtitleZH: '最大连续获胜交易',
        descriptionEN: 'Stay tuned of your winning streaks, by being alerted of your positive streaks.',
        descriptionES: 'Mantente al tanto de tus rachas ganadoras, siendo alertado de tus rachas positivas.',
        descriptionJA: '勝利の連続記録に注意し、ポジティブな連勝についてアラートを受け取ることで、勝利の連続記録を把握しましょう。',
        descriptionKO: '긍정적인 연속 기록에 대한 알림을 받아 성공 기록에 주의하세요.',
        descriptionPT: 'Fique atento às suas sequências vencedoras, sendo alertado sobre suas sequências positivas.',
        descriptionTH: 'ติดตามช่วงการชนะของคุณโดยได้รับการแจ้งเตือนเกี่ยวกับช่วงที่เป็นบวกของคุณ',
        descriptionVI: 'Theo dõi các chuỗi chiến thắng của bạn bằng cách được thông báo về các chuỗi tích cực của bạn.',
        descriptionZH: '通过获得有关您的积极连胜的提醒，随时了解您的胜利连胜。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Positive-Streak-Swiset.png'
    },
    {
        insightType: 'LOSING_STREAK',
        insightTypeES: 'RACHA_FALLIDAS',
        priority: 7,
        subtitleEN: 'Máx consecutive losing trades',
        subtitleES: 'Máximos perdidos consecutivamente',
        subtitleJA: '最大連続損失取引',
        subtitleKO: '최대 연속 손실 거래',
        subtitlePT: 'Máx negociações perdidas consecutivas',
        subtitleTH: 'การเทรดที่แพ้ติดต่อกันสูงสุด',
        subtitleVI: 'Tối đa thương mại thua liên tiếp',
        subtitleZH: '最大连续亏损交易',
        descriptionEN: 'Stay tuned of your losing streaks, by being alerted of your negative streaks.',
        descriptionES: 'Mantente al tanto de tus rachas de fallidas, siendo alertado de tus rachas negativas.',
        descriptionJA: '損失の連続記録に注意し、ネガティブな連敗についてアラートを受け取ることで、損失の連続記録を把握しましょう。',
        descriptionKO: '부정적인 연속 기록에 대한 알림을 받아 손실 기록에 주의하세요.',
        descriptionPT: 'Fique atento às suas sequências perdedoras, sendo alertado sobre suas sequências negativas.',
        descriptionTH: 'ติดตามช่วงการแพ้ของคุณโดยได้รับการแจ้งเตือนเกี่ยวกับช่วงที่เป็นลบของคุณ',
        descriptionVI: 'Theo dõi các chuỗi thua của bạn bằng cách được thông báo về các chuỗi tiêu cực của bạn.',
        descriptionZH: '通过获得有关您的负面连败的提醒，随时了解您的亏损连败。',
        color: '#FF4747',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Negative-Streak-Swiset.png'
    },
    {
        insightType: 'MOST_FREQUENT_TRADE_CLOSING_TIME',
        insightTypeES: 'TIEMPO_MÁS_FRECUENTE_DE_CIERRE',
        priority: 9,
        subtitleEN: 'Are the best day hours for winning',
        subtitleES: 'Son las mejores horas del día para ganar',
        subtitleJA: '勝利に最適な時間帯',
        subtitleKO: '성공하기에 가장 좋은 시간대입니다',
        subtitlePT: 'São as melhores horas do dia para ganhar',
        subtitleTH: 'เป็นช่วงเวลาที่ดีที่สุดของวันสำหรับการชนะ',
        subtitleVI: 'Là những giờ tốt nhất trong ngày để chiến thắng',
        subtitleZH: '是一天中获胜的最佳时段',
        descriptionEN: 'Enhance your trading time, by being alerted of your best/worst hours for trading.',
        descriptionES: 'Date cuenta del mejor tiempo para operar, siendo alertado de tus mejores/peores horas de trading.',
        descriptionJA: '取引の最適/最悪な時間帯についてアラートを受け取ることで、取引時間を向上させましょう。',
        descriptionKO: '거래에 가장 좋거나 나쁜 시간에 대한 알림을 받아 거래 시간을 개선하세요.',
        descriptionPT: 'Melhore seu tempo de negociação, sendo alertado sobre as melhores/piores horas para negociar.',
        descriptionTH: 'ปรับปรุงเวลาในการเทรดของคุณโดยได้รับการแจ้งเตือนเกี่ยวกับช่วงเวลาที่ดีที่สุด/แย่ที่สุดสำหรับการเทรด',
        descriptionVI: 'Nâng cao thời gian giao dịch của bạn bằng cách được thông báo về giờ tốt nhất/tồi tệ nhất để giao dịch.',
        descriptionZH: '通过获得有关您交易的最佳/最差时段的提醒，增强您的交易时间。',
        color: '#0092DD',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Most-Frequent-Time-Swiset.png'
    },
    {
        insightType: 'MILESTONE_TRADE',
        insightTypeES: 'HITOS_DE_TRADES',
        priority: 12,
        subtitleEN: 'Are you total trades',
        subtitleES: 'Han sido todos tus trades',
        subtitleJA: 'あなたの総取引数',
        subtitleKO: '총 거래량입니다',
        subtitlePT: 'São suas negociações totais',
        subtitleTH: 'เป็นการเทรดทั้งหมดของคุณ',
        subtitleVI: 'Là tổng số giao dịch của bạn',
        subtitleZH: '是您的交易总数',
        descriptionEN: 'Stay tuned of your records, being recognized by milestones.',
        descriptionES: 'Mantente al tanto de tus records, siendo reconocido por hitos.',
        descriptionJA: 'マイルストーンによって認識され、記録を把握し続けましょう。',
        descriptionKO: '마일스톤으로 인정받으며 자신의 기록을 지속적으로 확인하세요.',
        descriptionPT: 'Fique atento aos seus recordes, sendo reconhecido por marcos.',
        descriptionTH: 'ติดตามสถิติของคุณโดยได้รับการยอมรับจากเหตุการณ์สำคัญ',
        descriptionVI: 'Theo dõi các kỷ lục của bạn, được công nhận bằng các cột mốc.',
        descriptionZH: '通过里程碑的认可，随时了解您的记录。',
        color: '#0092DD',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Neutral-Streak-Swiset.png'
    },
    {
        insightType: 'BEST_NET_PROFIT',
        insightTypeES: 'MEJOR_TRADE',
        priority: 5,
        subtitleEN: 'Was the best profit ever',
        subtitleES: 'Has sido la mejor ganancia histórica',
        subtitleJA: '史上最高の利益',
        subtitleKO: '역대 최고의 수익이었습니다',
        subtitlePT: 'Foi o melhor lucro de sempre',
        subtitleTH: 'เป็นกำไรที่ดีที่สุดตลอดกาล',
        subtitleVI: 'Là lợi nhuận tốt nhất từ trước đến nay',
        subtitleZH: '是有史以来最好的利潤',
        descriptionEN: 'Stay tuned of your best trades and best profits.',
        descriptionES: 'Mantente al tanto de tus mejores trades y mejores beneficios.',
        descriptionJA: '最高の取引と最高の利益を把握し続けましょう。',
        descriptionKO: '최고의 거래와 최고의 수익에 주의하세요.',
        descriptionPT: 'Fique atento às suas melhores negociações e melhores lucros.',
        descriptionTH: 'ติดตามการเทรดที่ดีที่สุดและกำไรที่ดีที่สุดของคุณ',
        descriptionVI: 'Theo dõi các giao dịch tốt nhất và lợi nhuận tốt nhất của bạn.',
        descriptionZH: '随时了解您的最佳交易和最佳利潤。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Best-Net-Profit-Swiset.png'
    },
    {
        insightType: 'BEST_TRADE_RISK_REWARD',
        insightTypeES: 'MEJOR_TRADE_RISK_REWARD',
        priority: 11,
        subtitleEN: 'Is the best Risk/Reward ever',
        subtitleES: 'Ha sido el mejor Riesgo/Beneficio',
        subtitleJA: '史上最高のリスク/リワード比',
        subtitleKO: '최고의 위험/보상 비율입니다',
        subtitlePT: 'É o melhor Risco/Recompensa de sempre',
        subtitleTH: 'เป็นอัตราส่วนความเสี่ยง/ผลตอบแทนที่ดีที่สุดตลอดกาล',
        subtitleVI: 'Là tỷ lệ Rủi ro/Phần thưởng tốt nhất từ trước đến nay',
        subtitleZH: '是有史以来最好的风险/回报比',
        descriptionEN: 'Stay tuned of the best Risk/Reward of any trade.',
        descriptionES: 'Mantente al tanto de tu mejor Riesgo/Beneficio en algún trade.',
        descriptionJA: 'あらゆる取引の最高のリスク/リワード比を把握し続けましょう。',
        descriptionKO: '어떤 거래에서든 최고의 위험/보상 비율에 주의하세요.',
        descriptionPT: 'Fique atento ao melhor Risco/Recompensa de qualquer negociação.',
        descriptionTH: 'ติดตามอัตราส่วนความเสี่ยง/ผลตอบแทนที่ดีที่สุดของการเทรดใดๆ',
        descriptionVI: 'Theo dõi tỷ lệ Rủi ro/Phần thưởng tốt nhất của bất kỳ giao dịch nào.',
        descriptionZH: '随时了解任何交易的最佳风险/回报比。',
        color: '#0092DD',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Ratios-of-Swiset.png'
    },
    {
        insightType: 'CONSECUTIVE_SIDE',
        insightTypeES: 'LADO_CONSECUTIVO',
        priority: 10,
        subtitleEN: 'Is your side streak',
        subtitleES: 'Es tu racha actual de lado',
        subtitleJA: 'あなたの売買方向の連続記録',
        subtitleKO: '당신의 매매 방향 기록입니다',
        subtitlePT: 'É sua sequência de lado',
        subtitleTH: 'เป็นช่วงด้านของคุณ',
        subtitleVI: 'Là chuỗi bên của bạn',
        subtitleZH: '是您的买卖方向连续记录',
        descriptionEN: 'Stay tuned of your buy(long) or sell(short) streaks.',
        descriptionES: 'Mantente al tanto de tus rachas de compras(largos) o ventas(cortos).',
        descriptionJA: '買い（ロング）または売り（ショート）の連続記録を把握し続けましょう。',
        descriptionKO: '매수(롱) 또는 매도(숏) 연속 기록에 주의하세요.',
        descriptionPT: 'Fique atento às suas sequências de compra(longa) ou venda(curta).',
        descriptionTH: 'ติดตามช่วงการซื้อ(ยาว) หรือขาย(สั้น) ของคุณ',
        descriptionVI: 'Theo dõi các chuỗi mua(dài) hoặc bán(ngắn) của bạn.',
        descriptionZH: '随时了解您的买入（做多）或卖出（做空）连续记录。',
        color: '#0092DD',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Sides-Insights-Swiset.png'
    },
    {
        insightType: 'MONETARY_RISK_EXCEEDED',
        insightTypeES: 'RIESGO_MONETARIO_EXCEDIDO',
        priority: 8,
        subtitleEN: 'Is your average in the last trades',
        subtitleES: 'Es tu promedio en los últimos trades',
        subtitleJA: '最近の取引での平均',
        subtitleKO: '최근 거래의 평균입니다',
        subtitlePT: 'É sua média nas últimas negociações',
        subtitleTH: 'เป็นค่าเฉลี่ยของคุณในการเทรดล่าสุด',
        subtitleVI: 'Là trung bình của bạn trong các giao dịch gần đây',
        subtitleZH: '是您最近交易的平均值',
        descriptionEN: 'Improve your risk consistency, by being alerted of the risk anomalies.',
        descriptionES: 'Mejora tu consistencia de riesgo, siendo alertado por anomalías en riesgos asumidos.',
        descriptionJA: 'リスクの異常についてアラートを受け取ることで、リスクの一貫性を向上させましょう。',
        descriptionKO: '위험 이상 현상에 대한 알림을 받아 위험 일관성을 개선하세요.',
        descriptionPT: 'Melhore sua consistência de risco, sendo alertado sobre as anomalias de risco.',
        descriptionTH: 'ปรับปรุงความสม่ำเสมอในการรับความเสี่ยงของคุณโดยได้รับการแจ้งเตือนเกี่ยวกับความผิดปกติของความเสี่ยง',
        descriptionVI: 'Cải thiện tính nhất quán về rủi ro của bạn bằng cách được thông báo về các bất thường về rủi ro.',
        descriptionZH: '通过获得风险异常的提醒，提高您的风险一致性。',
        color: '#ffb25f',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Warning-Insight-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_MOODS',
        insightTypeES: 'RENDIMIENTO_POR_SENTIMIENTO',
        priority: 4,
        subtitleEN: 'Is your most winning mood',
        subtitleES: 'Es tu sentimiento más ganador',
        subtitleJA: '最も勝利の多いムード',
        subtitleKO: '가장 성공적인 기분입니다',
        subtitlePT: 'É seu humor mais vencedor',
        subtitleTH: 'เป็นอารมณ์ที่ชนะมากที่สุดของคุณ',
        subtitleVI: 'Là tâm trạng chiến thắng nhiều nhất của bạn',
        subtitleZH: '是您最成功的心情',
        descriptionEN: 'Stay tuned of the most profitable/winning mood.',
        descriptionES: 'Mantente al tanto de tus sentimientos más rentables/ganadores.',
        descriptionJA: '最も利益が上がる/勝利の多いムードを把握し続けましょう。',
        descriptionKO: '가장 수익성 있는/이기는 기분에 주의하세요.',
        descriptionPT: 'Fique atento ao humor mais lucrativo/vencedor.',
        descriptionTH: 'ติดตามอารมณ์ที่ทำกำไรได้มากที่สุด/ชนะมากที่สุด',
        descriptionVI: 'Theo dõi tâm trạng có lợi nhuận/chiến thắng nhất.',
        descriptionZH: '随时了解最有利可图/最成功的心情。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Best-Mood-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_STRATEGIES',
        insightTypeES: 'RENDIMIENTO_POR_ESTRATEGIA',
        priority: 1,
        subtitleEN: 'Is your most winning strategy',
        subtitleES: 'Es tu estrategia más ganadora',
        subtitleJA: '最も勝利の多い戦略',
        subtitleKO: '가장 성공적인 전략입니다',
        subtitlePT: 'É sua estratégia mais vencedora',
        subtitleTH: 'เป็นกลยุทธ์ที่ชนะมากที่สุดของคุณ',
        subtitleVI: 'Là chiến lược chiến thắng nhiều nhất của bạn',
        subtitleZH: '是您最成功的策略',
        descriptionEN: 'Stay tuned of the most profitable/winning strategy.',
        descriptionES: 'Mantente al tanto de tus estrategias más rentables/ganadoras.',
        descriptionJA: '最も利益が上がる/勝利の多い戦略を把握し続けましょう。',
        descriptionKO: '가장 수익성 있는/이기는 전략에 주의하세요.',
        descriptionPT: 'Fique atento à estratégia mais lucrativa/vencedora.',
        descriptionTH: 'ติดตามกลยุทธ์ที่ทำกำไรได้มากที่สุด/ชนะมากที่สุด',
        descriptionVI: 'Theo dõi chiến lược có lợi nhuận/chiến thắng nhất.',
        descriptionZH: '随时了解最有利可图/最成功的策略。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Best-Strategy-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_DAYS',
        insightTypeES: 'RENDIMIENTO_POR_DÍAS',
        priority: 3,
        subtitleEN: 'Is your most winning day of week',
        subtitleES: 'Es tu día de la semana más ganador',
        subtitleJA: '最も勝利の多い曜日',
        subtitleKO: '한 주에서 가장 성공적인 요일입니다',
        subtitlePT: 'É o seu dia da semana mais vencedor',
        subtitleTH: 'เป็นวันที่ชนะมากที่สุดในสัปดาห์ของคุณ',
        subtitleVI: 'Là ngày chiến thắng nhiều nhất trong tuần của bạn',
        subtitleZH: '是您一周中最成功的日子',
        descriptionEN: 'Stay tuned of the most profitable/winning day of week.',
        descriptionES: 'Mantente al tanto de tus días más rentables/ganadores.',
        descriptionJA: '最も利益が上がる/勝利の多い曜日を把握し続けましょう。',
        descriptionKO: '한 주에서 가장 수익성 있는/이기는 요일에 주의하세요.',
        descriptionPT: 'Fique atento ao dia da semana mais lucrativo/vencedor.',
        descriptionTH: 'ติดตามวันในสัปดาห์ที่ทำกำไรได้มากที่สุด/ชนะมากที่สุด',
        descriptionVI: 'Theo dõi ngày trong tuần có lợi nhuận/chiến thắng nhất.',
        descriptionZH: '随时了解一周中最有利可图/最成功的日子。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Best-day-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_STRATEGY_AND_ASSET',
        insightTypeES: 'RENDIMIENTO_POR_ESTRATEGIA_Y_ACTIVO',
        priority: 2,
        subtitleEN: 'Is your most winning strategy/asset',
        subtitleES: 'Es tu estrategia/activo más ganador',
        subtitleJA: '最も勝利の多い戦略/資産',
        subtitleKO: '가장 성공적인 전략/자산입니다',
        subtitlePT: 'É sua estratégia/ativo mais vencedor',
        subtitleTH: 'เป็นกลยุทธ์/สินทรัพย์ที่ชนะมากที่สุดของคุณ',
        subtitleVI: 'Là chiến lược/tài sản chiến thắng nhiều nhất của bạn',
        subtitleZH: '是您最成功的策略/资产',
        descriptionEN: 'Stay tuned of the most profitable/winning set of strategy and asset.',
        descriptionES: 'Mantente al tanto de tus conjuntos de estrategias y activos más rentables/ganadores.',
        descriptionJA: '最も利益が上がる/勝利の多い戦略と資産の組み合わせを把握し続けましょう。',
        descriptionKO: '가장 수익성 있는/이기는 전략과 자산 조합에 주의하세요.',
        descriptionPT: 'Fique atento ao conjunto mais lucrativo/vencedor de estratégia e ativo.',
        descriptionTH: 'ติดตามชุดกลยุทธ์และสินทรัพย์ที่ทำกำไรได้มากที่สุด/ชนะมากที่สุด',
        descriptionVI: 'Theo dõi bộ chiến lược và tài sản có lợi nhuận/chiến thắng nhất.',
        descriptionZH: '随时了解最有利可图/最成功的策略和资产组合。',
        color: 'var(--v-darkGreen-base)',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Best-Asset-Swiset.png'
    },
    {
        insightType: 'CONSISTENCY_RULE',
        insightTypeES: 'REGLA_DE_CONSISTENCIA',
        priority: 13,
        subtitleEN: 'Is the 30% of your positive profit',
        subtitleES: 'Representa el 30% de tus trades positivos',
        subtitleJA: 'あなたのプラス利益の30%',
        subtitleKO: '긍정적 수익의 30%입니다',
        subtitlePT: 'É 30% do seu lucro positivo',
        subtitleTH: 'เป็น 30% ของกำไรเชิงบวกของคุณ',
        subtitleVI: 'Là 30% lợi nhuận tích cực của bạn',
        subtitleZH: '是您正面利潤的30%',
        descriptionEN: 'Be a consistent trader, by being alerted of the non-consistency patterns.',
        descriptionES: 'Sé un trader consistente, siendo alertado de patrones no consistentes en tu operativa.',
        descriptionJA: '一貫性のないパターンについてアラートを受け取ることで、一貫したトレーダーになりましょう。',
        descriptionKO: '일관성 없는 패턴에 대한 알림을 받아 일관된 트레이더가 되세요.',
        descriptionPT: 'Seja um trader consistente, sendo alertado sobre os padrões de não-consistência.',
        descriptionTH: 'เป็นนักเทรดที่มีความสม่ำเสมอโดยได้รับการแจ้งเตือนเกี่ยวกับรูปแบบที่ไม่สม่ำเสมอ',
        descriptionVI: 'Trở thành một nhà giao dịch nhất quán bằng cách được thông báo về các mẫu không nhất quán.',
        descriptionZH: '通过获得有关非一致性模式的提醒，成为一个稳定的交易者。',
        color: '#0092DD',
        imageUrl: 'https://hub.swiset.com/wp-content/uploads/2021/02/Consistency-Insight-Swiset.png'
    },
];

export default insightsData;
